import { activateSemanticUI } from './popup';
jQuery(function () {
    $(document.body).on('change', 'input[type=file]', function (evt) {
        var fileInput = evt.target;
        if (fileInput && fileInput.form) {
            var filenameInput = fileInput.form.FileName;
            if (filenameInput) {
                if (fileInput.value) {
                    var filename = fileInput.value.replace(/C:\\fakepath\\/i, '');
                    filenameInput.value = filename;
                    filenameInput.classList.remove('hidden');
                    var sizeLimitStr = fileInput.getAttribute('data-size-limit');
                    var sizeLimit = sizeLimitStr ? +sizeLimitStr : 10000000;
                    if (fileInput.files && fileInput.files[0].size > sizeLimit) {
                        filenameInput.classList.add('warning-text');
                        $('.fn-file-upload-size-warning').removeClass('hidden');
                        $('.fn-show-file-details').addClass('hidden');
                    }
                    else {
                        filenameInput.classList.remove('warning-text');
                        $('.fn-file-upload-size-warning').addClass('hidden');
                        $('.fn-show-file-details').removeClass('hidden');
                    }
                }
                else {
                    filenameInput.classList.add('hidden');
                    $('.fn-file-upload-size-warning').addClass('hidden');
                }
            }
        }
    });
    $('.ts-show-house-files-btn').on('click', function () {
        $('.fn-show-upload-file').addClass('hidden');
        $('.fn-show-file-connections').removeClass('hidden');
        $('.fn-upload-file_input').removeAttr('required');
        $('#uploadNewFile').val('false');
    });
    $('.ts-show-upload-new-file-btn').on('click', function () {
        $('.fn-show-upload-file').removeClass('hidden');
        $('.fn-show-file-connections').addClass('hidden');
        $('.fn-upload-file_input').attr('required', 'required');
        $('.fn-connect-file_input').removeAttr('required');
        $('#uploadNewFile').val('true');
    });
    $('.fn-connect-file_input').on('change', function () {
        $('#upload-file-button').removeClass('button--disabled');
    });
});
$('.ts-file-upload-form').on('click', function () {
    $('.ts-upload-file-dialog').parent().addClass('visible');
    activateSemanticUI($('.ts-upload-file-dialog'));
});
$('.fn-reset-upload-file-btn').on('click', function () {
    $('.fn-show-file-details').addClass('hidden');
    $('.fn-file-input').addClass('hidden');
});
function validateFileUpload() {
    var uploadNewFile = $('#uploadNewFile');
    if (uploadNewFile && uploadNewFile.val() === 'false') {
        return true;
    }
    var fileInput = document.getElementById('File');
    var sizeLimitStr = fileInput.getAttribute('data-size-limit');
    var sizeLimit = sizeLimitStr ? +sizeLimitStr : 10000000;
    if (fileInput.files && fileInput.files[0].size > sizeLimit) {
        $('.fn-file-upload-size-warning').removeClass('hidden');
        return false;
    }
    return true;
}
